export const storage = {

    get<T>(key: string): T | null {
        try {
            const value = window.localStorage.getItem(key);
            if (value == null) return null;
            return JSON.parse(value) as T;
        } catch {
            return null;
        }
    },

    set<T>(key: string, value: T): void {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error("[Storage] set error", error);
        }
    },

    remove(key: string): void {
        window.localStorage.removeItem(key);
    },

    clear(): void {
        window.localStorage.clear();
    },

};